<template>
  <div :class="$style.component">
    <div
      :data-rid-id="riddleId"
      class="riddle_target"
    >
      <iframe
        :src="riddleSrc"
        ref="iframeRef"
        allow="autoplay"
        referrerpolicy="no-referrer"
      />
    </div>
  </div>
</template>

<script>
import {computed, ref} from '@vue/composition-api'

import useEventListener from '@/composition/useEventListener'
import {getStars} from '@/utils/stars'

export default {
  props: {
    riddleId: {type: String, required: true},
    /**
     * Some Riddle quiz types require the max score to be entered manually via
     * this prop.
     */
    answerCount: {type: Number, required: false},
  },
  setup (props, context) {
    const iframeRef = ref()
    const answerCount = ref(0)
    const correctAnswerCount = ref(0)

    if (props.answerCount) {
      answerCount.value = props.answerCount
    }

    useEventListener(window, 'message', event => {
      if (event.origin !== 'https://www.riddle.com') return
      if (!event.data.riddleEvent) return

      if (event.data.riddleEvent.action === 'answer-quiz') {
        answerCount.value++
      } else if (event.data.riddleEvent.action === 'answer-correct-quiz') {
        correctAnswerCount.value++
      } else if (event.data.riddleEvent.action === 'finish-quiz') {
        // Wait a bit so that the riddle iframe can post all messages before the iframe is removed.
        setTimeout(() => {
          context.emit('finish', {
            stars: getStars(correctAnswerCount.value, answerCount.value),
          })
        }, 100)
      } else if (event.data.riddleEvent.action === 'view-spot-result') {
        correctAnswerCount.value = event.data.riddleEvent.label
        // Wait a bit so that the riddle iframe can post all messages before the iframe is removed.
        setTimeout(() => {
          context.emit('finish', {
            stars: getStars(correctAnswerCount.value, answerCount.value),
          })
        }, 100)
      } else if (event.data.riddleEvent.action === 'view-lineup-result') {
        correctAnswerCount.value = event.data.riddleEvent.label
        // Wait a bit so that the riddle iframe can post all messages before the iframe is removed.
        setTimeout(() => {
          context.emit('finish', {
            stars: getStars(correctAnswerCount.value, answerCount.value),
          })
        }, 100)
      }
    })

    removeElementIfExists('riddle-embed-js')
    const riddleEmbedJs = document.createElement('script')
    riddleEmbedJs.setAttribute('id', 'riddle-embed-js')
    riddleEmbedJs.setAttribute('src', 'https://www.riddle.com/files/js/embed.js')
    document.head.appendChild(riddleEmbedJs)

    removeElementIfExists('riddle-embed-css')
    const riddleEmbedCss = document.createElement('link')
    riddleEmbedCss.setAttribute('id', 'riddle-embed-css')
    riddleEmbedCss.setAttribute('rel', 'stylesheet')
    riddleEmbedCss.setAttribute('href', 'https://www.riddle.com/files/css/embed.css')
    document.head.appendChild(riddleEmbedCss)

    return {
      iframeRef,
      riddleSrc: computed(() => {
        return `https://www.riddle.com/a/${props.riddleId}`
      }),
    }
  },
}

function removeElementIfExists (id) {
  const el = document.getElementById(id)
  if (el) {
    el.parentNode.removeChild(el)
  }
}
</script>

<style module lang="scss">
.component {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  padding: variables.$spacing-16;
  width: 100%;
  min-height: 100%;

  > * {
    width: 100%;
  }

  iframe {
    border: 0;
    width: 100%;
  }
}
</style>
